import * as React from 'react';

import { useEnterpriseAdminContext } from 'bundles/admin-dashboard/components/EnterpriseAdminContext';
import { useThirdPartyOrganization } from 'bundles/admin-dashboard/components/ThirdPartyOrganizationProvider';
import { AdminAuthNavigation } from 'bundles/enterprise-admin-navigation/components/AdminAuthNavigation';

const WithGlobalNavAndStyleGuide: React.LegacyFunctionComponentWithChildren<{}> = ({ children, ...props }) => {
  const org = useThirdPartyOrganization();
  const { adminRoleType } = useEnterpriseAdminContext();

  return (
    <div className="styleguide">
      <AdminAuthNavigation thirdPartyOrganization={org} adminRoleType={adminRoleType} />
      {React.cloneElement(children as JSX.Element, props)}
    </div>
  );
};

export default WithGlobalNavAndStyleGuide;
